import { PurchaseTransactionDto } from "../../../dtos/transactions/PurchaseTransactionDto";
import { format } from "date-fns";
import { DataGrid } from "devextreme-react";
import { Column, ColumnChooser, Grouping, GroupPanel, Pager, Paging, SearchPanel } from "devextreme-react/data-grid";
import { MovementTypeColumn } from "./MovementTypeColumn";
import React from "react";

interface IProps {
    items: PurchaseTransactionDto[];
}
// settlementCustomerMovementTransactionDtos
export const PurchaseTransactionTable = ({ items }: IProps) => {
    const pageSizes = [10, 25, 50, 100];

    return (
        <>
            <div className={"overflow-auto"}>
                <DataGrid
                    dataSource={items}
                    sorting={{ mode: "multiple" }}
                    allowColumnReordering={true}
                    rowAlternationEnabled={false}
                    showBorders={false}
                    showRowLines={true}
                    allowColumnResizing={true}
                    selection={{ mode: "single" }}
                    loadPanel={{ enabled: true, showIndicator: true, showPane: false }}
                >
                    <ColumnChooser enabled={true} />
                    <GroupPanel visible={true} />
                    <SearchPanel visible={true} highlightCaseSensitive={true} />
                    <Grouping autoExpandAll={false} />

                    <Column dataField="tableMovementType"
                            dataType="string"
                            caption={"Movement Type"}
                            width={100}
                            cellRender={(column: any) => {
                                return <MovementTypeColumn column={column} />
                            }} />
                    <Column width={150} dataField={"period"} dataType={"datetime"} caption={"Period"}
                        sortOrder={"asc"}
                        sortIndex={1} />
                    <Column width={150} dataField={"companyId"} dataType="string" />
                    <Column width={150} dataField={"companyName"} dataType="string" />
                    <Column width={150} dataField={"vendorId"} dataType="string" />
                    <Column width={150} dataField={"vendorName"} dataType="string" />
                    <Column width={150} dataField={"productId"} dataType="string" />
                    <Column width={150} dataField={"productName"} dataType="string" />
                    <Column width={150} dataField={"quantity"} dataType="number" />
                    <Column width={150} dataField={"amount"} dataType="number" />

                    <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
                    <Paging defaultPageSize={10} />
                </DataGrid>
            </div>
        </>
    )
}
